import React from 'react';
import IconPanelContainer from "./IconPanelContainer";

const EmployeeInformationContainer = ({title, icon, children}) => {
  return (
    <IconPanelContainer
      icon={icon}
      title={title}
      container={{
        className: 'ed-grid s-grid-2 row-gap s-gap-12px',
      }}
    >
      {children}
    </IconPanelContainer>
  );
};

export default EmployeeInformationContainer;
